import { graphDataText, graphNodeLabel } from './';
export const graphNodeTitle = (theme, parameters) => {
  const common = {
    textColor: graphNodeLabel(theme, parameters).textColor,
    fontFamily: graphNodeLabel(theme, parameters).fontFamily,
    fontSize: graphNodeLabel(theme, parameters).fontSize,
    fontStyle: graphNodeLabel(theme, parameters).fontStyle
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          fontWeight: graphDataText(theme, parameters).fontWeight
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          fontWeight: graphNodeLabel(theme, parameters).fontWeight
        };
      }
    default:
      {
        return {
          ...common,
          fontWeight: graphDataText(theme, parameters).fontWeight
        };
      }
  }
};
//# sourceMappingURL=graphNodeTitle.js.map